import { render, staticRenderFns } from "./NavPillsLargeWidget.vue?vue&type=template&id=01a0f288&"
import script from "./NavPillsLargeWidget.vue?vue&type=script&lang=js&"
export * from "./NavPillsLargeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a0f288')) {
      api.createRecord('01a0f288', component.options)
    } else {
      api.reload('01a0f288', component.options)
    }
    module.hot.accept("./NavPillsLargeWidget.vue?vue&type=template&id=01a0f288&", function () {
      api.rerender('01a0f288', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/NavPillsLargeWidget.vue"
export default component.exports